import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreRoutingModule } from './core-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './component/login/login';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './component/sidebar/sidebar-component';
import { AuthGuard } from './guard/auth.guard';
import { AdminGuard } from './guard/admin.guard';
import { 
  LucideAngularModule, 
  Car, User, Lock, AlertCircle, Loader2, ArrowRight, Eye, EyeOff,
  // ✅ New icons
  Calendar, CheckCircle, Settings, Users, Palmtree, LogOut, ChevronLeft, ChevronRight, Menu 
} from 'lucide-angular';

@NgModule({
  declarations: [    
    LoginComponent,
    SidebarComponent,
    
  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LucideAngularModule.pick({ 
      Car, User, Lock, AlertCircle, Loader2, ArrowRight, Eye, EyeOff,
      Calendar, CheckCircle, Settings, Users, Palmtree, LogOut, ChevronLeft, ChevronRight, Menu 
    })  ], 
  providers: [
    AuthGuard,
    AdminGuard
  ],
  exports: [
    LoginComponent,
    SidebarComponent
  ]
})
export class CoreModule { }
